import React, { SetStateAction, useRef, useState } from 'react';
import { Accordion } from '@uk-source-web/accordion';
import {
  CollapsibleContainer,
  CollapsibleContainerBody,
  CollapsibleContainerHeader,
} from '@uk-source-web/collapsible-container';
import { Paragraph } from '@uk-source-web/paragraph';
import { Icon } from '@uk-source-web/icon';
import {
  CompletedPurchaseProcessing,
  TenantPortingItemHeading,
  TenantPortingItemInfo,
  TenantPortingOrderInfo,
  TenantPortingOrderItem,
} from './TenantPortingItem.styles';
import { Heading } from '@uk-source-web/heading';
import TenantPortingNextSteps from '../TenantPortingNextSteps/TenantPortingNextStep';
import { TenantPortingItemProps } from './TenantPortingItem.types';
import { getImage, getSrc } from 'gatsby-plugin-image';
import Image from '@legacy-vfuk/core-image';
import { AdditionalData } from '../../SWBasket/BasketItem/BasketItem.styles';
import StateNotification from '@legacy-vfuk/core-state-notification';
import { CalloutMessage } from '../../OrderCompletedPurchase/OrderCompletedPurchase.styles';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

const TenantPortingItem = ({
  calloutMessages,
  calloutMessageNonMsft,
  microsoftState,
  initiallyOpenIds = [],
  ...item
}: TenantPortingItemProps) => {
  const thumbnailIconSrc =
    typeof item.thumbnailIcon == 'string'
      ? item.thumbnailIcon
      : getSrc(item.thumbnailIcon) ?? getImage(item.thumbnailIcon)?.placeholder?.fallback;

  const isMicrosoftProduct = item.msftProduct;

  const handleResendEmail = () => {
    console.log('resens email for test');
  };

  return (
    <div>
      <Accordion
        id="accordion-id"
        dataSelectorPrefix="accordion"
        dataAttributes={{
          'data-test-id': 'accordion',
        }}
        initiallyOpenIds={initiallyOpenIds}
      >
        {[
          <CollapsibleContainer id={item.id}>
            <TenantPortingItemInfo>
              <Icon name={'warning'} group="hifiLight" />
              <Paragraph>
                {isMicrosoftProduct
                  ? 'Microsoft requires you to finish setting up your subscription.'
                  : 'There are next steps to be done'}
              </Paragraph>
            </TenantPortingItemInfo>
            {!isMicrosoftProduct ? (
              <TenantPortingOrderInfo>
                <TenantPortingOrderItem>
                  <Paragraph weight={4}>Order number:</Paragraph>
                  <Paragraph>32093094</Paragraph>
                </TenantPortingOrderItem>
                <TenantPortingOrderItem>
                  <Paragraph weight={4}>Date of order:</Paragraph>
                  <Paragraph>01/05/2023</Paragraph>
                </TenantPortingOrderItem>
                <TenantPortingOrderItem>
                  <Paragraph weight={4}>Status</Paragraph>
                  <Paragraph>Placed order</Paragraph>
                </TenantPortingOrderItem>
              </TenantPortingOrderInfo>
            ) : (
              <></>
            )}
            <TenantPortingItemHeading>
              <Image alt="image" sm={{ src: thumbnailIconSrc ?? '' }} />
              <CollapsibleContainerHeader>
                {' '}
                <Heading level={4} weight={3} text={item?.dxlInformation?.name ?? item?.name} />
              </CollapsibleContainerHeader>
            </TenantPortingItemHeading>
            <CollapsibleContainerBody>
              {isMicrosoftProduct &&
                calloutMessages?.map(item => (
                  <TenantPortingNextSteps
                    id={''}
                    key={item.name}
                    __typename={'ContentfulSectionTenantPortingSteps'}
                    name={item.name}
                    messageHeading={item.messageHeading}
                    adminMessage={item.adminMessage}
                    notAdminMessage={item.notAdminMessage}
                    adminTenantPortingItems={item.adminTenantPortingItems}
                    notAdminTenantPortingItems={item.notAdminTenantPortingItems}
                    accesssButton={item.accesssButton}
                    copyLinkButton={item.copyLinkButton}
                  />
                ))}

              {!isMicrosoftProduct && Array.isArray(calloutMessageNonMsft) && calloutMessageNonMsft.length > 0 && (
                <>
                  <Heading level={4} weight={3}>
                    Next Step
                  </Heading>
                  {calloutMessageNonMsft.map(callout => (
                    <CompletedPurchaseProcessing key={callout.id}>
                      {callout?.icon && <Icon name={callout.icon} group="system" size={3} />}
                      <CalloutMessage>{documentToReactComponents(JSON.parse(callout.message.raw))}</CalloutMessage>
                    </CompletedPurchaseProcessing>
                  ))}
                </>
              )}
              {isMicrosoftProduct && (
                <AdditionalData>
                  <StateNotification
                    key={microsoftState}
                    state={'success'}
                    heading={{ text: 'Account activation email sent', level: 3 }}
                    button={{
                      text: 'Resend email',
                      onClick: handleResendEmail,
                    }}
                  >
                    <div style={{ color: '#008A00', marginBottom: '10px' }}>
                      In case you close this window, we emailed the access to the account activation process to
                      loremipsum@lorem.com. If you are unable to find it, check the Spam folder or request to resend the
                      email.
                    </div>
                  </StateNotification>
                </AdditionalData>
              )}
            </CollapsibleContainerBody>
          </CollapsibleContainer>,
        ]}
      </Accordion>
    </div>
  );
};

export default TenantPortingItem;
